import { cn } from '../../utils/cn';

import type { JSX } from 'react';

interface ListNotionItemProps {
  className?: string;
  description?: string;
  icon?: JSX.Element;
  shortcut?: JSX.Element | string | number;
  title: string;
  truncate?: boolean;
}

/**
 * @param truncate **optional** `true` by default. If it's true truncates the title and description to only one line
 */
export function ListNotionItem({
  className,
  description,
  icon,
  shortcut,
  title,
  truncate = true,
}: ListNotionItemProps) {
  return (
    <div className={cn('flex w-full items-center gap-3', className)}>
      {!icon ? null : (
        <div className="flex size-8 max-h-8 min-h-8 max-w-8 min-w-8 items-center justify-center overflow-hidden rounded-full border border-input">
          {icon}
        </div>
      )}
      <div className="flex w-full flex-col justify-center">
        <p
          className={cn('list-notion-item-title mb-1 w-full text-sm leading-tight', {
            'line-clamp-1': truncate,
          })}
        >
          {title}
        </p>
        {description ? (
          <p
            className={cn('w-full text-xs text-muted-foreground', {
              'line-clamp-1': truncate,
            })}
          >
            {description}
          </p>
        ) : null}
      </div>
      {shortcut === undefined ? null : (
        <div className="flex w-12 max-w-12 min-w-12 items-center justify-center overflow-hidden text-xs text-accent">
          {shortcut}
        </div>
      )}
    </div>
  );
}
